import React, { createContext, useContext } from 'react';

const EMPTY_OBJECT = Object.freeze({});
export const defaultBehavior = {
  recordViewSpeakerProfileActivity: () => EMPTY_OBJECT,
  recordSpeakerFileDownloadActivity: () => EMPTY_OBJECT
};

const SpeakersWidgetBehavior = createContext(defaultBehavior);

export default SpeakersWidgetBehavior;
export function withBehavior(Component) {
  return props => {
    const behavior = useContext(SpeakersWidgetBehavior);
    return <Component behavior={behavior} {...props} />;
  };
}
